import React, {useState, useEffect} from 'react';
import { IonContent, IonHeader, IonPage } from '@ionic/react';
import { RouteComponentProps } from 'react-router-dom';
import { RouteParams } from '../domain/RouteParams';
import HeaderActivity from '../components/HeaderActivity';
import AddEditActivityItem from '../components/AddEditActivityItem';
import { Plugins } from '@capacitor/core';

const { Network } = Plugins;

const AddEditActivity: React.FC<RouteComponentProps>= ({match, history, location}) => {
  const actyivityId = (match.params as RouteParams).id ;
  const type =  (match.params as RouteParams).type;
  const isExternal = (match.params as RouteParams).isExternal;
  const [isOnline, setIsOnline] = useState<boolean>(window.localStorage.getItem("online") !== "0");
  
  useEffect(() => {
    Network.addListener("networkStatusChange", status => {
      setIsOnline(status.connected);
      if (status.connected)
        window.localStorage.setItem("online", "1");
      else
        window.localStorage.setItem("online", "0");
    });

    return () => Network.removeAllListeners(); 
  }, [])

  return (
    <IonPage>
      <IonHeader mode="ios">
        <HeaderActivity 
          history={history} 
          match={match} 
          location={location} 
          type={actyivityId === '0' ? 'add' : 'edit'} 
          activityTypeId={type.toString()}
          isExternal = {isExternal}>        
        </HeaderActivity>
      </IonHeader>
      <IonContent fullscreen>
        <AddEditActivityItem 
          match = {match} 
          history = {history} 
          location = {location}
          isOnline = {isOnline}
          isExternal = {isExternal}>  
        </AddEditActivityItem>
      </IonContent>
    </IonPage>
  );
};

export default AddEditActivity;